export default __webpack_public_path__ + "5ad9451940bf73253484fa500633df93.png";